export const FAMILY_DEGREES = [
  {
    key: 'grau_um',
    name: '1º Grau',
  },
  {
    key: 'grau_dois',
    name: '2º Grau',
  },
  {
    key: 'grau_tres',
    name: '3º Grau',
  },
]

export const ATOPIA_OPTIONS = [
  { key: 'asma', name: 'Asma' },
  { key: 'rinite_alergica', name: 'Rinite Alérgica' },
  { key: 'dermatite_atopica', name: 'Dermatite Atópica' },
]

export const SYMPTOM_OPTIONS = {
  maiores: [
    {
      key: 'prurido',
      name: 'Prurido',
    },
    {
      key: 'morfologia',
      name: 'Morfologia e distribuição típica: liquenificação ou linearidade flexural em adultos ou  envolvimento facial e de áreas extensoras em bebês e crianças',
    },
    {
      key: 'dermatite_cronica',
      name: 'Dermatite crônica e recorrente',
    },
    {
      key: 'atopia',
      name: 'História familiar ou pessoal de atopia',
      options: [
        {
          key: 'asma',
          name: 'Asma',
          checkbox: [
            {
              key: 'paciente',
              name: 'Paciente',
            },
            {
              key: 'familiar',
              name: 'Familiar:',
              checkbox: [
                {
                  key: 'grau_um',
                  name: '1º Grau',
                },
                {
                  key: 'grau_dois',
                  name: '2º Grau',
                },
                {
                  key: 'grau_tres',
                  name: '3º Grau',
                },
              ],
            },
          ],
        },
        {
          key: 'rinite_alergica',
          name: 'Rinite Alérgica',
          checkbox: [
            {
              key: 'paciente',
              name: 'Paciente',
            },
            {
              key: 'familiar',
              name: 'Familiar:',
              checkbox: [
                {
                  key: 'grau_um',
                  name: '1º Grau',
                },
                {
                  key: 'grau_dois',
                  name: '2º Grau',
                },
                {
                  key: 'grau_tres',
                  name: '3º Grau',
                },
              ],
            },
          ],
        },
        {
          key: 'dermatite_atopica',
          name: 'Dermatite Atópica',
          checkbox: [
            {
              key: 'paciente',
              name: 'Paciente',
            },
            {
              key: 'familiar',
              name: 'Familiar:',
              checkbox: [
                {
                  key: 'grau_um',
                  name: '1º Grau',
                },
                {
                  key: 'grau_dois',
                  name: '2º Grau',
                },
                {
                  key: 'grau_tres',
                  name: '3º Grau',
                },
              ],
            },
          ],
        },
      ],
    },
  ],

  menores: [
    {
      label: 'Características faciais:',
      symptoms: [
        {
          key: 'escurecimento_periorbital',
          name: 'Escurecimento periorbital',
          category: 'faciais',
        },
        {
          key: 'palidez_facial',
          name: 'Palidez/eritema facial',
          category: 'faciais',
        },
        {
          key: 'queilite',
          name: 'Queilite',
          category: 'faciais',
        },
        {
          key: 'prega_dennie_morgan',
          name: 'Prega de Dennie-Morgan',
          category: 'faciais',
        },
        {
          key: 'pitiriase_alba',
          name: 'Pitiríase alba (face, pescoço, tórax superior e braços)',
          category: 'faciais',
        },
      ],
    },
    {
      label: 'Triggers:',
      symptoms: [
        {
          key: 'intolerancia_la_solventes',
          name: 'Intolerância com lã e solventes',
          category: 'triggers',
        },
        {
          key: 'intolerancia_alimentar',
          name: 'Intolerância alimentar',
          category: 'triggers',
        },
        {
          key: 'fatores_emocionais_ambientais',
          name: 'Piora com fatores emocionais e ambientais',
          category: 'triggers',
        },
        {
          key: 'prurido_sudorese',
          name: 'Prurido com sudorese ',
          category: 'triggers',
        },
      ],
    },
    {
      label: 'Complicações:',
      symptoms: [
        {
          key: 'tendencia_infeccoes_pele',
          name: 'Tendência para infecções de pele (Streptococcus aureus e Herpes simplex)',
          category: 'complicacoes',
        },
        {
          key: 'imunidade_celular_comprometida',
          name: 'Imunidade celular comprometida',
          category: 'complicacoes',
        },
        {
          key: 'reatividade_imunidade_tipo_um',
          name: 'Reatividade para testes de imunidade tipo I',
          category: 'complicacoes',
        },
        {
          key: 'conjuntivite_recorrente',
          name: 'Conjuntivite recorrente',
          category: 'complicacoes',
        },
        {
          key: 'ceratocone',
          name: 'Ceratocone',
          category: 'complicacoes',
        },
        {
          key: 'catarata_subcapsular_anterior',
          name: 'Catarata subcapsular anterior',
          category: 'complicacoes',
        },
      ],
    },
    {
      label: 'Outros:',
      symptoms: [
        {
          key: 'inicio_precoce',
          name: 'Início precoce',
          category: 'outros',
        },
        {
          key: 'zerose',
          name: 'Xerose',
          category: 'outros',
        },
        {
          key: 'ictiose',
          name: 'Ictiose',
          category: 'outros',
        },
        {
          key: 'hiperlinearidade_palmar',
          name: 'Hiperlinearidade palmar',
          category: 'outros',
        },
        {
          key: 'queratose_pilar',
          name: 'Queratose pilar',
          category: 'outros',
        },
        {
          key: 'ige_serico_elevado',
          name: 'IgE sérico elevado',
          category: 'outros',
        },
        {
          key: 'eczema_mamilo',
          name: 'Eczema de mamilo',
          category: 'outros',
        },
        {
          key: 'rugas_pescoco_anterior',
          name: 'Rugas no pescoço anterior',
          category: 'outros',
        },
        {
          key: 'acentuacao_peripilar',
          name: 'Acentuação peripilar',
          category: 'outros',
        },
        {
          key: 'dermografismo_branco_tardio',
          name: 'Dermografismo branco/branqueamento tardio ',
          category: 'outros',
        },
      ],
    },
  ],
}

export const SYMPTOM_OPTIONS_SUMMARIZED = {}
